<template>
  <div>
    <v-dialog v-model="dialog" fullscreen content-class="payment-success">
      <div class="payment-success__wrapper">
        <div class="py-5 mb-5">
          <div class="w-100 d-flex justify-center">
            <router-link to="/" class="mw-145">
              <img
                :src="require('@/assets/nav_logo_primary.png')"
                width="145px"
              />
            </router-link>
          </div>
        </div>
        <div class="w-100 d-flex justify-center">
          <div class="payment-success__content">
            <div class="payment-success__title d-flex align-center">
              <div class="icon">
                <img src="/static/images/circle_check.svg" class="w-100" />
              </div>
              <div>Payment successful</div>
            </div>

            <div class="d-flex payment-success__description">
              <div class="user">
                <div>Hi, John!</div>
                <div>You’ve upgraded.</div>
                <div class="note" v-if="accountCategory === 'creator'">
                  Your creator account is pending verification. Please allow up
                  to 72 hours. Your listener subscription is active, download
                  the app & go!
                </div>
                <div v-else class="note">
                  Your listener subscription is active, download the app & go!
                </div>
              </div>
              <div class="minw-315">
                <img src="/static/images/people.svg" class="w-100" />
              </div>
            </div>
            <div class="d-flex align-center gap-14 payment-success__icon">
              <div
                class="mw-145 cursor-pointer"
                @click="openQrCode(qrCodeTypeList.IOS)"
              >
                <img src="/static/images/app-store.svg" class="w-100" />
              </div>
              <div
                class="mw-145 cursor-pointer"
                @click="openQrCode(qrCodeTypeList.ANDROID)"
              >
                <img class="w-100" src="/static/images/play-store.svg" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-dialog>
    <QrCode ref="qrCode" />
  </div>
</template>

<script>
import QrCode from "@/components/base/qr_code";
import { QrCodeTypeList } from "@/helper";

export default {
  props: {
    accountCategory: {
      type: String,
      default: "creator",
    },
  },
  components: {
    QrCode,
  },
  data() {
    return {
      dialog: false,
      qrCodeTypeList: QrCodeTypeList,
    };
  },
  methods: {
    openPaymentSuccess() {
      this.dialog = true;
    },
    openQrCode(type) {
      return this.$refs.qrCode.openQrCode(type);
    },
  },
};
</script>

<style lang="scss" scoped>
.payment-success {
  &__wrapper {
    background: #eceff2;
    width: 100%;
    height: 100vh;
  }

  &__title {
    color: #fff;
    font-family: DM Sans;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: 120%;
    border-radius: 30px 30px 0px 0px;
    background: #1ea73c;
    height: 82px;
    padding: 0 52px;
    gap: 16px;
  }

  &__content {
    border-radius: 30px;
    background: #fff;
    max-width: 738px;
    height: 519px;
  }

  &__description {
    margin: 40px 52px;
  }

  &__icon {
    padding: 20px 52px;
  }
}

.user {
  margin-top: 44px;
  color: #333;
  font-family: DM Sans;
  font-size: 34px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
}

.note {
  color: #000;
  font-family: DM Sans;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  margin-top: 20px;
}

.icon {
  max-height: 32px;
  max-width: 32px;
}

.mw-145 {
  max-width: 145px;
}

.minw-315 {
  min-width: 315px;
}
</style>



// WEBPACK FOOTER //
// paymentSuccess.vue?7c669e56